import {
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
  colors,
  Box,
} from "@material-ui/core";
import { InputField } from "../../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../../components/input-button/InputButton";
import { PhoneNumberInput } from "../../../../../../components/phone-number/PhoneNumberInput";
import { FormattedMessage, useIntl } from "react-intl";
import React, { useState, useEffect } from "react";
import ICIPAdminService from "../../../../../../services/ICIPAdminService";
import GeneralSettingService from "../../../../../../services/GeneralSettingService";
import { Alert } from "@material-ui/lab";

interface FirstUserVerifyProps {
  settings: {};
  raffleDraw: {};
}

const useStyles = makeStyles((theme) => ({
  generalGrid: {
    padding: 10,
  },
  specialBox: {
    padding: 10,
  },
}));

export const FirstUserVerify = (props: FirstUserVerifyProps) => {
  const { settings } = props;
  const classes = useStyles(props);
  const { formatMessage } = useIntl();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [succeed, setSucceed] = useState(false);
  const [raffleDrawInProgress, setRaffleDrawInProgress] = useState(() => {});
  const [currentSettings, setCurrentSettings] = useState(() => settings);
  const [winnersTable, setWinnersTable] = useState((): Array<any> => []);
  const [isAllowed, setIsAllowed] = useState(true);

  const onWinnerChange = (index: number, phone: string) => {
    let currentWinnersTable = [...winnersTable];
    currentWinnersTable[index] = phone;
    setWinnersTable(currentWinnersTable);
  };

  const initScreenValues = async () => {
    setLoading(true);
    let response = await ICIPAdminService.getAuthUser();

    if (response.isSuccess) {
      let userId = response.data.data;

      let otherResponse = await ICIPAdminService.getGeneralSettingForRaffleDay();
      if (otherResponse.isSuccess) {
        let data = otherResponse.data.data;

        let currentSettings = data["settings"];
        if (currentSettings["first_user"] == userId) {
          let raffleDrawInProgress = data["raffle_draw"];

          if (raffleDrawInProgress !== null) {
            setRaffleDrawInProgress(raffleDrawInProgress);
            loadRaffleDrawInProgress(currentSettings, raffleDrawInProgress);
          }

          setLoading(false);
          setIsAllowed(true);
          setCurrentSettings(currentSettings);
        } else {
          setIsAllowed(false);
          setLoading(false);
          console.log(data["settings"]);
        }
      }
    } else {
      setIsAllowed(false);
      setLoading(false);
    }
  };

  const loadRaffleDrawInProgress = (settings: any, raffleDraw: any) => {
    const numberOfWinners = raffleDraw["number_of_winners"];
    let winners =
      settings["first_user_numbers"] == null
        ? null
        : Object.values(JSON.parse(settings["first_user_numbers"]));

    if (winners === null) {
      winners = Array(numberOfWinners).fill("");
    } else {
      let fillWinners = Array(numberOfWinners - winners.length).fill("");
      winners = [...winners, ...fillWinners];
    }

    setWinnersTable(winners);
  };

  const saveWinners = () => {
    let currentVerificationTable = [...winnersTable];
    let currSettings = { ...currentSettings };
    let data: any = {};
    currSettings["first_user_numbers"] = JSON.stringify(
      currentVerificationTable
    );

    data["package_validity_limit"] = currSettings["package_validity_limit"];
    data["renew_raffle_participant"] = currSettings["renew_raffle_participant"];
    data["tombola_ended_at"] = currSettings["tombola_ended_at"];
    data["first_user_numbers"] = JSON.stringify(currentVerificationTable);
    data["second_user_numbers"] = null;

    GeneralSettingService.setGeneralSettings(data).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        setError(true);
        setLoading(false);
      }
    });
  };

  const renderForm = () => {
    if (raffleDrawInProgress !== null && raffleDrawInProgress !== undefined) {
      return (
        <>
          <Grid className={classes.specialBox} item xs={4} sm={4} lg={4}>
            <Typography variant="h4" component="h4">
              <FormattedMessage id="sharedScreen.editWinners" />
            </Typography>
          </Grid>
          {winnersTable.map((value, index) => {
            let inputName = `winner_${index}`;
            return (
              <Grid className={classes.generalGrid} xs={12} sm={6} lg={4}>
                <InputField
                  fullWidth
                  value={value}
                  label={`${formatMessage({
                    id: "sharedScreen.winnerPhoneNumber",
                  })} ${index}`}
                  placeholder={`${formatMessage({
                    id: "sharedScreen.winnerPhoneNumber",
                  })} ${index}`}
                  name={inputName}
                  onChange={(event) =>
                    onWinnerChange(index, event.target.value)
                  }
                />
              </Grid>
            );
          })}

          <Grid className={classes.specialBox}>
            {!loading ? (
              <InputButton
                color="secondary"
                size="medium"
                variant="contained"
                type="submit"
                onClick={saveWinners}
              >
                <FormattedMessage id="sharedScreen.verifyRaffleDrawEntries" />
              </InputButton>
            ) : (
              <CircularProgress />
            )}

            {error !== null ? (
              <Grid className={classes.generalGrid} xs={12} sm={6} lg={4}>
                <Typography variant="h4" component="h4">
                  <Alert severity="error">{error}</Alert>
                </Typography>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </>
      );
    }

    return <></>;
  };

  useEffect(() => {
    initScreenValues();
  }, []);

  return (
    <>
      {isAllowed ? (
        <>
          <Grid className={classes.generalGrid} xs={12} sm={12} lg={12}>
            <Typography variant="h4" component="h4">
              <div>
                <FormattedMessage id="sharedScreen.raffleDrawInProgress" />
              </div>
              {raffleDrawInProgress != null ? (
                raffleDrawInProgress["raffle_draw_date"] ??
                "Aucun pour le moment"
              ) : (
                <Typography variant="h4" component="h4">
                  <FormattedMessage id="sharedScreen.noneRaffleDrawAtTheMoment" />
                </Typography>
              )}
            </Typography>
          </Grid>
          {renderForm()}
        </>
      ) : (
        <Grid className={classes.generalGrid} xs={12} sm={6} lg={4}>
          <Typography variant="h4" component="h4">
            <Alert severity="error">
              <FormattedMessage id="sharedScreenyouAreNotAllowedToSeeThisTab" />
            </Alert>
          </Typography>
        </Grid>
      )}
    </>
  );
};
